import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { styled } from "@mui/material/styles";
import { Checkbox, FormControlLabel, SvgIcon } from "@mui/material";
import BryxColors from "../types/theme";
import withStaticMode from "../hocs/withStaticMode";
const BryxCheckbox = styled(({ compact, ...rest }) => (_jsx(Checkbox, { ...rest, disableRipple: true, checkedIcon: _jsx(SvgIcon, { sx: { height: compact ? "11px" : "16px", width: compact ? "12px" : "18px" }, children: _jsx("path", { d: "M8.79506 15.875L5.32506 12.405C4.93506 12.015 4.30506 12.015 3.91506 12.405C3.52506 12.795 3.52506 13.425 3.91506 13.815L8.09506 17.995C8.48506 18.385 9.11506 18.385 9.50506 17.995L20.0851 7.415C20.4751 7.025 20.4751 6.395 20.0851 6.005C19.6951 5.615 19.0651 5.615 18.6751 6.005L8.79506 15.875Z" }) }), indeterminateIcon: _jsx(_Fragment, {}), icon: _jsx(SvgIcon, {}) })))(({ theme, compact }) => {
    const palette = theme.palette.mode;
    const calcSize = compact ? "16px" : "24px";
    const calcBorder = compact ? "3px" : "4px";
    return {
        padding: "0px",
        width: calcSize,
        height: calcSize,
        "& .PrivateSwitchBase-input": {
            width: compact ? "14px" : "22px",
            height: compact ? "14px" : "22px",
        },
        "& .MuiCheckbox-root": {
            boxShadow: "none",
            backgroundColor: "transparent !important",
            color: "unset !important",
            border: `1px solid ${BryxColors.notify(palette, "inactive")}`,
            borderRadius: calcBorder,
            "& svg": {
                "&:not(:hover)": {
                    fill: BryxColors.brandPrimary(palette),
                },
            },
        },
        "&.MuiCheckbox-colorPrimary": {
            border: `1px solid ${BryxColors.notify(palette, "inactive")}`,
            borderRadius: calcBorder,
            "& svg": {
                "&:not(:hover)": {
                    fill: BryxColors.brandPrimary(palette),
                },
            },
        },
        "&.MuiCheckbox-colorSecondary": {
            border: `1px solid ${BryxColors.notify(palette, "inactive")}`,
            borderRadius: calcBorder,
            "& svg": {
                "&:not(:hover)": {
                    fill: BryxColors.brandPrimary(palette),
                },
            },
        },
        "&:hover": {
            "& .MuiFormControlLabel-label": {
                color: BryxColors.brand1(palette) + " !important",
            },
            borderColor: BryxColors.brand1(palette) + " !important",
        },
        "&.Mui-checked": {
            "&:not(:hover):not(.MuiCheckbox-indeterminate)": {
                color: BryxColors.brand3(palette),
            },
            "&:not(.MuiCheckbox-indeterminate)": {
                backgroundColor: BryxColors.brand3(palette),
                border: `1px solid ${BryxColors.brandPrimary(palette)}`,
            },
            borderRadius: calcBorder,
            "&:before": {
                content: "''",
                position: "absolute",
                left: 0,
                top: 0,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
            },
            "&:hover *": {
                fill: BryxColors.brand1(palette),
                "& .MuiFormControlLabel-label": {
                    color: BryxColors.brand1(palette) + " !important",
                },
            },
        },
        "&.MuiCheckbox-indeterminate": {
            color: "unset !important",
        },
    };
});
// @TODO -- RMS-2247, withStaticMode should piggy back off the styling from 2247 with disabled={isStatic} in `withStaticMode`
const BryxLabeledCheckbox = withStaticMode(styled(({ compact, label, ...rest }) => {
    if (label) {
        return _jsx(FormControlLabel, { ...rest, label: label, control: _jsx(BryxCheckbox, { compact: compact }) });
    }
    return _jsx(BryxCheckbox, { compact: compact });
})((props) => {
    const calcBorder = props.compact ? "3px" : "4px";
    return {
        marginLeft: "0",
        "& .MuiFormControlLabel-label": {
            fontSize: "13px",
            fontWeight: 400,
            lineHeight: "18px",
            paddingLeft: "8px",
            color: BryxColors.notify(props.theme.palette.mode, "inactive"),
            "&.Mui-disabled": {
                color: BryxColors.notify(props.theme.palette.mode, "inactive"),
            },
        },
        "&:hover": {
            "&:not(.Mui-disabled)": {
                "& .MuiFormControlLabel-label": {
                    color: BryxColors.brand1(props.theme.palette.mode) + " !important",
                },
                "& .MuiCheckbox-root": {
                    border: `1px solid ${BryxColors.brand1(props.theme.palette.mode)}`,
                    borderRadius: calcBorder,
                    boxShadow: "none",
                    "& svg": {
                        fill: BryxColors.brand1(props.theme.palette.mode) + " !important",
                    },
                },
                "& .MuiCheckbox-colorPrimary": {
                    border: `1px solid ${BryxColors.brand1(props.theme.palette.mode)}`,
                    borderRadius: calcBorder,
                    boxShadow: "none",
                    "& svg": {
                        fill: BryxColors.brand1(props.theme.palette.mode),
                    },
                },
                "& .MuiCheckbox-colorSecondary": {
                    border: `1px solid ${BryxColors.brand1(props.theme.palette.mode)}`,
                    borderRadius: calcBorder,
                    boxShadow: "none",
                    "& svg": {
                        fill: BryxColors.brand1(props.theme.palette.mode),
                    },
                },
                "& .Mui-checked": {
                    fill: BryxColors.brand1(props.theme.palette.mode),
                },
            },
        },
        "&:focus": {
            "&:not(.Mui-disabled)": {
                "& .MuiFormControlLabel-label": {
                    color: BryxColors.brand1(props.theme.palette.mode) + " !important",
                },
                "& .MuiCheckbox-root": {
                    border: `1px solid ${BryxColors.brand1(props.theme.palette.mode)}`,
                    borderRadius: calcBorder,
                    boxShadow: "none",
                    "& svg": {
                        fill: BryxColors.brand1(props.theme.palette.mode) + " !important",
                    },
                },
                "& .MuiCheckbox-colorPrimary": {
                    border: `1px solid ${BryxColors.brand1(props.theme.palette.mode)}`,
                    borderRadius: calcBorder,
                    boxShadow: "none",
                    "& svg": {
                        fill: BryxColors.brand1(props.theme.palette.mode),
                    },
                },
                "& .MuiCheckbox-colorSecondary": {
                    border: `1px solid ${BryxColors.brand1(props.theme.palette.mode)}`,
                    borderRadius: calcBorder,
                    boxShadow: "none",
                    "& svg": {
                        fill: BryxColors.brand1(props.theme.palette.mode),
                    },
                },
                "& .Mui-checked": {
                    fill: BryxColors.brand1(props.theme.palette.mode),
                },
            },
        },
        "& .Mui-checked ~ .MuiFormControlLabel-label": {
            color: BryxColors.brandPrimary(props.theme.palette.mode),
        },
    };
}));
export { BryxCheckbox, BryxLabeledCheckbox };
